import angular from 'angular';
import FooterComponent from './footer.component';

export default angular
  .module('accountsApp.footer', [])
  .component('footer', FooterComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/footer/index.js